import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";

i18n
   // 使用 i18next-http-backend
   .use(Backend)
   // 將 i18next 傳入 react-i18next 裡面
   .use(initReactI18next)  
   // 實例化 initReactI18next
   .init({
      backend: {
         //網頁載入時去下載語言檔的位置
         loadPath: "/js/react_common/public/locales/{{lng}}/{{ns}}.json",
         // 只載入指定的語言，不自動載入基礎語言（例如 zh-TW 不會自動載入 zh）
         loadLanguageOnly: true,
      },
      //debug: true,
      // 當目前的語言檔找不到對應的字詞時，會用 fallbackLng 作為預設語言
      // 為 zh-TW 和 zh 設定空陣列以禁用相互回退，其他語言回退到 en
      fallbackLng: {
         'zh-TW': [],
         'zh': [],
         'en': [],
         'default': ['en']
      },
      // 預設語言
      lng: "zh-TW",
      // 明確指定支援的語言列表，防止自動語言代碼拆分
      supportedLngs: ['zh-TW', 'zh', 'en'],
      interpolation: {
         // 是否要讓字詞 escaped 來防止 xss 攻擊，這裡因為 React.js 已經做了，就設成 false即可
         escapeValue: false,
      },
      react: {
            transSupportBasicHtmlNodes: true,
            transKeepBasicHtmlNodesFor: ["br", "strong", "b", "i"],
            useSuspense: false,
        }
   });

// 移除衝突語言資源的函數
const removeConflictingResources = () => {
	// 如果當前語言是 zh-TW，移除 zh 資源以防止回退到簡體中文
	if (i18n.language === 'zh-TW' && i18n.hasResourceBundle('zh', 'translation')) {
		i18n.removeResourceBundle('zh', 'translation');
	}
	// 如果當前語言是 zh (簡體中文)，移除 zh-TW 資源以防止回退到繁體中文
	// 但只有在 zh 資源已載入的情況下才移除 zh-TW
	if (i18n.language === 'zh') {
		if (!i18n.hasResourceBundle('zh', 'translation')) {
			// zh 資源未載入，強制載入
			i18n.reloadResources('zh', 'translation').then(() => {
				// 載入完成後，移除 zh-TW 資源
				if (i18n.hasResourceBundle('zh-TW', 'translation')) {
					i18n.removeResourceBundle('zh-TW', 'translation');
				}
			});
		} else if (i18n.hasResourceBundle('zh-TW', 'translation')) {
			i18n.removeResourceBundle('zh-TW', 'translation');
		}
	}
};

i18n.on('languageChanged', (lng) => {
	// 語言變更後，移除衝突的資源
	setTimeout(() => {
		removeConflictingResources();
	}, 100);
});

i18n.on('loaded', (loaded) => {
	// 資源載入後，移除衝突的資源
	removeConflictingResources();
});

export default i18n;
